module.exports = __webpack_public_path__ + "static/media/1.b2d72f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/1051/1.jpg
// module id = 422
// module chunks = 0